import { createContext } from 'react';

export interface AccountInfo {
  id: string;
  name: string;
  subdomain: string;
  hasMacros: boolean;
  salesforceInstance: string;
}

export const AccountInfoContext = createContext<AccountInfo>({
  id: null,
  name: null,
  subdomain: null,
  hasMacros: null,
  salesforceInstance: null,
});
